import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import cx from "classnames";
import { BifIconFilters2 } from "banafo-design-system";
import { ActionIcon } from "@mantine/core";
const FilterMenu = forwardRef(({ isOpen, onClick, className }, ref) => {
    return (_jsx(ActionIcon, { ref: ref, onClick: onClick, className: cx("burger-wrapper", { "burger-wrapper-expanded": isOpen }, className), variant: "transparent", "aria-label": "Settings", loading: false, children: _jsx(BifIconFilters2, {}) }));
});
export default FilterMenu;
